// PocketBase init — see ../pocketbase at the repo root ("pocketbase.exe
// serve") and ../roja-app/POCKETBASE_SCHEMA.md for the collections this
// console reads/writes. Same server as roja-app, but this app authenticates
// against the separate `admins` collection, never `users`.
import PocketBase from "pocketbase";

export const pb = new PocketBase(import.meta.env.VITE_POCKETBASE_URL || "http://127.0.0.1:8090");

// The SDK cancels any in-flight request that shares a method+path with a new one. The
// sidebar's live badge counts (useQueueCounts.ts) and each page's own list query hit the
// same collections at the same moment, so the page's request got cancelled and its
// spinner never cleared. Every call here is independent, so opt out globally.
pb.autoCancellation(false);
